(() => {
  'use strict';
  const fields = [
    ['size', /\b(size|sizes|diameter|width|wide|tall)\b/i, 'Size', ' in'],
    ['boltOption', /\b(bolts?|patterns?|lug count|how many lugs)\b/i, 'Bolt pattern', ''],
    ['offset', /\b(offsets?|et)\b/i, 'Offset', ' mm'],
    ['backspace', /\b(backspac\w*|back spac\w*)\b/i, 'Backspace', ' in'],
    ['msrp', /\b(msrp|price|pricing|costs?|how much)\b/i, 'MSRP (each)', ''],
    ['hubBore', /\b(bores?|hubs?)\b/i, 'Center bore', ' mm'],
    ['loadRating', /\b(loads?|capacity|ratings?)\b/i, 'Load rating', ' lb'],
    ['finish', /\b(finish|finishes|color|colour|black|bronze|chrome|milled|machined)\b/i, 'Finish', ''],
    ['lugSeat', /\b(lug.?seat|seat type|mag|conical|ball seat)\b/i, 'Lug seat', ''],
    ['wheelCap', /\b(cap|caps)\b/i, 'Center cap', ''],
    ['lugnutType1', /\b(lug.?nut|hardware|nut type)\b/i, 'Lug nut type 1', ''],
    ['lugnutType2', /\b(lug.?nut|hardware|nut type)\b/i, 'Lug nut type 2', ''],
    ['lugnutOpenClosed', /\b(lug.?nut|open.end|closed.end)\b/i, 'Lug nut end', ''],
    ['countryOfOrigin', /\b(made|country|origin|manufactured)\b/i, 'Country of origin', ''],
    ['finishWarranty', /\b(warranty|warranties|coverage)\b/i, 'Finish warranty', ''],
    ['structureWarranty', /\b(warranty|warranties|coverage)\b/i, 'Structural warranty', ''],
    ['tpmsCompatible', /\b(tpms|sensors?)\b/i, 'TPMS compatibility', ''],
    ['winterApproved', /\b(winter|snow)\b/i, 'Winter approved', ''],
    ['productWeight', /\b(weights?|weighs?|heavy)\b/i, 'Product weight', ' lb'],
    ['wheelLipSize', /\b(lip)\b/i, 'Wheel lip size', ''],
    ['liftRecommended', /\b(lift|level|lifted)\b/i, 'Level or lift kit recommended', ''],
    ['adapterAvailable', /\b(adapter|adaptor)\b/i, '8 to 10 lug adapters available', ''],
    ['material', /\b(material|aluminum|aluminium|alloy|made of)\b/i, 'Material', ''],
    ['upc', /\b(upc|barcode)\b/i, 'UPC', ''],
    ['duallyWheel', /\b(dually|dual rear)\b/i, 'Dually wheel', ''],
    ['screw', /\b(screw)\b/i, 'Screw', '']
  ];
  const compact = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const normalized = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const present = value => value !== null && value !== undefined && String(value).trim() !== '';
  const intent = question => ({
    fitment: /\b(fit|fits|fitment|compatible with|work on|work with|rub|rubbing|clearance|will these|will they)\b/i.test(question),
    fields: fields.filter(([, pattern]) => pattern.test(question)),
    all: /\b(spec|specs|specifications|details|tell me about)\b/i.test(question)
  });
  const identify = (question, rows) => {
    const text = ` ${normalized(question)} `;
    const exact = rows.filter(row => present(row.sku) && text.includes(` ${normalized(row.sku)} `));
    if (exact.length) return exact;
    const tokens=String(question).match(/[a-z0-9]+(?:[-.][a-z0-9]+)*/gi)||[];
    const prefixes=tokens.map(compact).filter(token=>token.length>=5 && /^\d{4}/.test(token));
    const partial=rows.filter(row=>prefixes.some(token=>compact(row.sku).startsWith(token)));
    if(partial.length)return partial;
    const styles=rows.filter(row => [row.styleNumber, row.wheelName].some(value => present(value) && String(value).length >= 3 && text.includes(` ${normalized(value)} `)));
    const finishes=[...new Set(rows.map(row=>normalized(row.finish)).filter(value=>value.length>=3 && text.includes(` ${value} `)))];
    const candidates=styles.length?styles:rows;
    return finishes.length?candidates.filter(row=>finishes.includes(normalized(row.finish))):styles;
  };
  const facts = (rows, selectedFields) => selectedFields.map(([key, , label, unit]) => ({
    key, label,
    entries: rows.map(row => ({sku: row.sku, value: key === 'msrp'
      ? (row.msrp?.applicable === true && row.msrp.currency === 'USD' && present(row.msrp.amount) && Number.isFinite(Number(row.msrp.amount)) && Number(row.msrp.amount) > 0
        ? '$' + Number(row.msrp.amount).toFixed(2) + ' USD' : null)
      : present(row[key]) ? String(row[key]) + unit : null}))
  }));
  window.MayhemSupportAnswers = {fields, intent, identify, facts, compact};
})();


